import { Field } from './Field';
import { IMultiField } from './IMultiField';
import { ComparisonType } from './ComparisonType';

export class MultiCollectionField extends Field implements IMultiField<any> {
  public values: any[];

  constructor(name: string, description: string, values: any[] = null, comparisonType: ComparisonType = null) {
    super(name, description, MultiCollectionField.typeName(), comparisonType);
    this.values = values;
  }

  public static typeName(): string {
    return "io.indexed.domainmodel.search.advanced.MultiCollectionField";
  }
}
